import { Filter } from "@/common/model/Filter";
import { Nullable } from "@/general/custom-types/CustomTypes";

export class WorkPeriodFilter extends Filter {
  constructor(
    identifier?: Nullable<string>,
    client?: Nullable<number[]>,
    facility?: Nullable<number[]>,
    country?: Nullable<string>
  ) {
    super("work-period-filter");
  }

  clear(): void {}

  toQueryParam(): string {
    const query: string = "";
    return query;
  }
}
